<template>
  <Patch>
    <h5 slot="title">罰單管理</h5>

  </Patch>
</template>

<script>
import Patch from '../common/AdminPatch';

export default {
  name: 'ADCManagement',
  components: {
    Patch,
  },
};
</script>



// WEBPACK FOOTER //
// TicketManagement.vue?3a7a32d7